import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';
import http from '../config/http-service';
import {
  getCrmSupplierContactQuotasEndpointIdentifier,
  ICrmSupplierContactQuotaData,
} from './use-get-crm-supplier-contact-quotas-api';

const endpoint = 'ums/v1/crm/management/suppliers/contact-quotas';

export type UpdateCrmSupplierContactQuotaPayload = {
  supplierId?: number;
  quota?: number;
  remaining?: number;
};

type TData = ICrmSupplierContactQuotaData;
type TError = AxiosError;
type TVariables = { id: number; data: UpdateCrmSupplierContactQuotaPayload };

type Options = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;
type TReturnType = ReturnType<typeof useMutationWrapper<TData, TError, TVariables>>;

export function useUpdateCrmSupplierContactQuotaApi(options?: Options): TReturnType {
  const queryClient = useQueryClient();
  const { onSuccess: userOnSuccess, ...restOptions } = options || {};

  const mutationFn = async ({ id, data }: TVariables): Promise<TData> => {
    const { data: responseData } = await http.put(`${endpoint}/${id}`, data);
    return responseData;
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: endpoint,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([getCrmSupplierContactQuotasEndpointIdentifier]);
      queryClient.invalidateQueries([endpoint, variables.id]);
      if (userOnSuccess) {
        userOnSuccess(data, variables, context);
      }
    },
    ...restOptions,
  });
}
